// This file contains a simple global store for managing tepProducts data
// and a function to fetch the data from the server.
// It uses a singleton pattern to ensure that the store is only created once
// and can be accessed globally.
import layoutSlice from './layoutSlice'

// Global store object
const store = {
  tepProducts: [],
  tepProductColors: [],
  tepProductCorners: [],
  tepProductFinishes: [],
  tepProductShapes: [],
  loading: {
    tepProducts: false,
    tepProductColors: false,
    tepProductCorners: false,
    tepProductFinishes: false,
    tepProductShapes: false
  },
  error: {
    tepProducts: null,
    tepProductColors: null,
    tepProductCorners: null,
    tepProductFinishes: null,
    tepProductShapes: null
  },
  fetched: {
    tepProducts: false,
    tepProductColors: false,
    tepProductCorners: false,
    tepProductFinishes: false,
    tepProductShapes: false
  },
  apiEndpoint: {
    tepProducts: '/api/tep-products',
    tepProductColors: '/api/tep-product-colors',
    tepProductCorners: '/api/tep-product-corners',
    tepProductFinishes: '/api/tep-product-finishes',
    tepProductShapes: '/api/tep-product-shapes'
  }
}

// This is a helper function to fetch data from the server
async function getFromStore (key) {
  // If an unknown key is passed, Throw an error
  if (!(key in store.apiEndpoint)) {
    throw new Error(`Unknown key: ${key}`)
  }

  // If the data is already fetched, return it from the store
  if (store.fetched[key]) {
    console.log(`Data for ${key} is already fetched`)
    console.log('cached data', store[key])
    return store[key]
  }

  const siteId = layoutSlice.state.site._id || null
  if (!siteId) {
    console.error('Site ID is not available')
    return []
  }

  try {
    console.log(`Fetching ${key} from ${store.apiEndpoint[key]}?siteId=${siteId}`)
    store.loading[key] = true

    const response = await window.fetch(`${store.apiEndpoint[key]}?siteId=${siteId}`)
    if (!response.ok) {
      throw new Error(response.statusText || `Failed to fetch ${key}`)
    }

    const data = await response.json()
    store[key] = data[key] || []
    store.fetched[key] = true
    return data[key]
  } catch (error) {
    store.error[key] = error.message || `Failed to fetch ${key}`
    console.error(`Error fetching ${key}:`, store.error[key])
    return []
  } finally {
    store.loading[key] = false
  }
}

export async function getTepProducts () {
  return getFromStore('tepProducts')
}
export async function getTepProductColors () {
  return getFromStore('tepProductColors')
}
export async function getTepProductCorners () {
  return getFromStore('tepProductCorners')
}
export async function getTepProductFinishes () {
  return getFromStore('tepProductFinishes')
}
export async function getTepProductShapes () {
  return getFromStore('tepProductShapes')
}
export async function getAllTepData () {
  const results = await Promise.all([
    getTepProducts(),
    getTepProductColors(),
    getTepProductCorners(),
    getTepProductFinishes(),
    getTepProductShapes()
  ])

  return {
    tepProducts: results[0],
    tepProductColors: results[1],
    tepProductCorners: results[2],
    tepProductFinishes: results[3],
    tepProductShapes: results[4]
  }
}
